import React from 'react'
import { Card, Col, Modal, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faRocket } from "@fortawesome/free-solid-svg-icons";
import { Alert } from "react-bootstrap"
import { useState, useEffect } from 'react'
import ContactUs from './ContactUs';
import ThreeDLogo from '../../sketchfab/ThreeDLogo';

const Footer = () => {

  return (
    <>
        <footer className='no-border rounded-0 footer-wrapper' id="CONTACT">
            <div className="footer-content container">
                <Row className='footer-top px-md-3'>
                    {/* <Col xs={{ span:4, offset:0 }} md={{ span:3, offset:0 }}> */}
                    {/* <Col md={4} className=' justify-content-end threed-logo-container'>
                        <ThreeDLogo />
                    </Col> */}
                    <Col md={7}>
                        <div className="text-center-">
                            <a href='https://www.paracosma.com' target='_blank' className=' text-decoration-none' title='www.paracosma.com'>
                                <Card.Img className=' w-50' src={"/assets/footer/footer_paracosma _logo.png"} alt="" />
                            </a>
                        </div>
                        
                    {/* </Col> */}
                    {/* <Col xs={{ span:4, offset:3 }} md={{ span:3, offset:5 }}>
                       <a href="https://www.facebook.com/paracosmaInc" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_fb.png"} alt="" /> </a>
                       <a href="https://www.instagram.com/paracosmainc" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_ig.png"} alt="" /> </a>
                       <a href="https://www.linkedin.com/company/paracosma/" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_linkedin.png"} alt="" /> </a>
                    </Col> */}
                {/* </Row>

                <div className='product-border pt-4 pb-3'></div>
                <Row className='footer-mid-section py-2'> */}
                    {/* <Col md={7}> */}
                    <div className='product-border pt-4 pb-3'></div>
                        <p className="footer-title">
                        About Paracosma
                        </p>
                        <div className='product-border'></div>
                        <Card.Text className='footer-desc text-white pr-md-5 mr-md-5'>
                        Founded in 2016 and recognized as one of the leading global AR-VR Solutions Providers, Paracosma has over 500 employee-years of experience developing immersive 3D solutions. Through hundreds of client projects and the creation of over ten thousand 3D models and Digital Twins, Paracosma learned two things: All of technology is transitioning from 2D to 3D; and, AR/VR remain too complex and expensive to be broadly adopted. Paracosma’s 3D Training and Marketing Platform was built from this experience to solve those problems. Paracosma’s 3D Training and Marketing Platform brings the benefits of the 3D transition to Training and Marketing. Broad libraries of 3D content shared by increasing numbers of users, lowers the costs of 3D content for each subscriber. While, intuitive player features make that 3D content easily accessible from any device. AI-powered content creation, library search, and user instructions further lower costs and ease access.Join Paracosma today in transitioning your business and industry from 2D to 3D, through the power of Paracosma’s 3D Training and Marketing Platform.
                        </Card.Text>
                    </Col>
                    <Col md={5}>
                        <div className='contact-footer my-2 '>
                            <div className="col-lg-10 contact-footer-container mx-auto">
                                <h1 className="font-weight-light text-center mt-2 fw-bolder">Contact Us</h1>
                                <p className="mx-2 ">We welcome your inquiries! Please use the space below to share your message, along with your contact information and interests. Our team is committed to swift responses. Thank you for getting in touch!</p>
                               <ContactUs />
                            </div>
                        </div>
                    </Col>

                </Row>
            </div>

            <Row className='footer-bottom-section mx-0 px-0'>
                <Col sm={{span:6, offset:3}} className="footer-bottom-text text-center text-white">
                    © Copyright {new Date().getFullYear()} by <a href="https://www.paracosma.com"  rel="noreferrer">Paracosma, Inc</a>. All right reserved.
                </Col>
            </Row>
        </footer>
        
      
    </>
  )
}

export default Footer